export enum CanPayResults {
  Yes = 'Yes',
  NoPaymentCard = 'NoPaymentCard',
  PaymentCardsExpired = 'PaymentCardsExpired',
}
